/**
 * What a prerendered page was rendered from, keyed by whatever the page chooses (`"article"`, `"feed"`, ...).
 * Values are plain JSON: the prerender writes them into the page's data element (`AppHtml` data) and the browser reads them back
 * with `readAppData`.
 */
export type SiteSeeds = Record<string, unknown>;

export type AppData = { url: string; seeds: SiteSeeds };

let current: SiteSeeds = {};

export const setSeeds = (seeds: SiteSeeds): void => {
  current = seeds;
};

/** A page's own first data, or undefined when it was not prerendered or the visitor has navigated on since. */
export const readSeed = <T>(key: string): T | undefined => current[key] as T | undefined;

/** Seeds describe one document; the first client-side navigation makes them stale. */
export const clearSeeds = (): void => {
  current = {};
};
